import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Login from './components/Login/Login';
import Error from './components/Error';
import CadastroOlt from './components/CadastroOlt';
import Dashboard from './components/Dashboard/Dashboard';
import ListaOlts from './components/ListaOlts/ListaOlts';
import CadastroVlan from './components/Vlans/CadastroVlan';
import CadastroCaixa from './components/CadastroCaixa';
import ListaCaixas from './components/ListaCaixas';
import ListaVlans from './components/Vlans/ListaVlans';
import CadastroUsuarios from './components/Usuarios/Cadastro';
import ListaUsuarios from './components/Usuarios/Lista';
import RequireAuth from './helpers/RequireAuth';

class App extends Component {

  render() {
    return (
      <HashRouter>
        <div>
       <Switch>
          <Route path="/" component={Login} exact />
          <Route path="/dashboard" component={RequireAuth(Dashboard)} exact />
          <Route path="/cadOlt" component={RequireAuth(CadastroOlt)}  exact /> 
          <Route path="/listaOlts" component={RequireAuth(ListaOlts)} exact />
          <Route path="/cadastroVlans" component={RequireAuth(CadastroVlan)} exact />
          <Route path="/listaVlans" component={RequireAuth(ListaVlans)} exact />
          <Route path="/cadastroCaixa" component={RequireAuth(CadastroCaixa)} exact />
          <Route path='/cadUsuario' component={RequireAuth(CadastroUsuarios)} exact />
          <Route path='/listaUsuarios' component={RequireAuth(ListaUsuarios)} exact />
          <Route path="/listaCaixas" component={RequireAuth(ListaCaixas)} exact />
         <Route component={Error} exact/>
        </Switch>
        </div>
      </HashRouter>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js